var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"major_selected_subjects"},[_c('div',{staticClass:"content"},[_c('router-view',{attrs:{"src":_vm.src,"quanzhong":_vm.quanzhong,"mubiaozhuanye":_vm.mubiaozhuanye,"checked":_vm.checked},on:{"go-next":function($event){return _vm.mubiaozhuanyes($event)}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }